import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class SharedNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the preventCrossCustomerAccess global action. */
    this.preventCrossCustomerAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "preventCrossCustomerAccess",
      operationName: "preventCrossCustomerAccess",
      operationReturnType: "SharedPreventCrossCustomerAccess",
      namespace: "shared",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "shared",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  SharedNamespace
};
//# sourceMappingURL=shared.js.map
